module.exports = __webpack_public_path__ + "themes/mf/font/proximasoft-regular-webfont.woff2";


//////////////////
// WEBPACK FOOTER
// ./themes/mf/font/proximasoft-regular-webfont.woff2
// module id = 146
// module chunks = 3